import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';
import api from '../lib/api';
import { acceptPendingInvite } from '../lib/pendingInvite';

export function SSOCallbackPage() {
  const [searchParams] = useSearchParams();
  const { login } = useAuthContext();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const code = searchParams.get('code');
    const token = searchParams.get('token');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setError('Sign in failed. Please try again.');
      return;
    }

    if (code) {
      api
        .post<{ token: string }>('/auth/exchange', { code })
        .then(async (res) => {
          let sessionToken = res.data.token;
          const upgraded = await acceptPendingInvite(sessionToken);
          if (upgraded) sessionToken = upgraded;
          login(sessionToken);
          navigate('/', { replace: true });
        })
        .catch(() => {
          setError('Sign in failed. The link may have expired — please try again.');
        });
      return;
    }

    if (token) {
      const doLogin = async () => {
        let sessionToken = token;
        const upgraded = await acceptPendingInvite(sessionToken);
        if (upgraded) sessionToken = upgraded;
        login(sessionToken);
        navigate('/', { replace: true });
      };
      const t = window.setTimeout(() => void doLogin(), 350);
      return () => window.clearTimeout(t);
    }

    setError('Invalid or missing authentication token.');
  }, [searchParams, login, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-sm border text-center">
          <div className="text-4xl mb-4">&#x26A0;&#xFE0F;</div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Sign in failed</h2>
          <p className="text-gray-600 mb-6">{error}</p>
          <Link
            to="/login"
            className="inline-block bg-green-700 text-white py-2 px-4 rounded-md font-medium hover:bg-green-800 transition-colors"
          >
            Back to login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <p className="text-gray-600">Signing you in...</p>
    </div>
  );
}
